import Vue from 'vue'

const ConfigApp = {}

ConfigApp.install = function (vue, options) {
  Vue.prototype.$config = options
}

export default ConfigApp
